<template>
    <widget title="研究工作室" :router="router" :class="'widget_level'+swWidth">
        <div class="warp_main">
                <div class="count_main">
                    <div class="count_item">
                        <span v-if="swWidth == 1"><img src="../img/master/ico5.png"></span>
                        <strong>{{currentStudio.achieveNum || 0}}</strong>
                        <div>我的成就</div>
                    </div>
                    <div class="count_item">
                        <span v-if="swWidth == 1"><img src="../img/master/ico1.png"></span>
                        <strong>{{currentStudio.memberNum || 0}}</strong>
                        <div>成员数</div>
                    </div>
                    <div class="count_item">
                        <span v-if="swWidth == 1"><img src="../img/master/ico3.png"></span>
                        <strong>{{currentStudio.browseNum || 0}}</strong>
                        <div>访问量</div>
                    </div>
                    <div class="count_item">
                        <span v-if="swWidth == 1"><img src="../img/master/ico2.png"></span>
                        <strong>{{currentStudio.activityNum || 0}}</strong>
                        <div>活动数</div>
                    </div>
                    <div class="count_item">
                        <span v-if="swWidth == 1"><img src="../img/master/ico4.png"></span>
                        <strong>{{currentStudio.resAuditNum || 0}}</strong>
                        <div>资源数</div>
                    </div>
                    <div class="count_item">
                        <span v-if="swWidth == 1"><img src="../img/master/ico6.png"></span>
                        <strong>{{currentStudio.weightValue || 0}}</strong>
                        <div>总活跃度</div>
                    </div>
                </div>
                <el-tabs v-model="activeName" v-if="swWidth != 1">
                    <el-tab-pane label="最新动态" name="first">
                        <div v-for="(i,index) in studioDynamicList" :key="index" class="dynamic_ceil" v-if="studioDynamicList.length > 0">>
                            <i></i>
                            <span>{{i.createTime | dateFormatMd}}</span>
                            <div>{{i.dynamicTitle}}</div>
                        </div>
                        <div v-if="studioDynamicList.length == 0" class="noData"></div> 
                    </el-tab-pane>
                    <el-tab-pane label="最新活动" name="second">
                        <div v-for="(i,index) in activitys" :key="index" class="activity_ceil" v-if="activitys.length > 0">
                            <span class="type">
                                <template v-if="i.organizationType == 1">协同备课</template>
                                <template v-if="i.organizationType == 2">约听课评</template>
                                <template v-if="i.organizationType == 3">专家讲座</template>
                                <template v-if="i.organizationType == 4">视频课例</template>
                                <template v-if="i.organizationType == 5">文档研讨</template>
                            </span>
                            <div class="activity_info">
                                <div class="activity_tit">{{i.activityName}}</div>
                                <div class="activity_about">
                                    <span>{{i.beginDate | dateFormatYmdHS}}开始</span>
                                    <span>{{i.participantsNumber}}人参与</span>
                                </div>
                                <span class="status color1" v-if="i.status == 0">未开始</span>
                                <span class="status color2" v-else-if="i.status == 1">进行中</span>
                                <span class="status color3" v-else-if="i.status == 2">已结束</span>
                            </div>
                        </div>
                        <div v-if="activitys.length == 0" class="noData"></div>
                    </el-tab-pane>
                </el-tabs>
            </div>
    </widget>
</template>
<script>
import widget from './warp'
export default {
    components: {
        widget
    },
    props:{
        title:{
            type:String
        },
        swWidth:{
            type:Number
        },
    },
    data(){
        return {
            activeName:'first',
            router:'master_studio_master_member',
            studiosId:'',
            studioQuery: {
                size: 10,
                page: 0,
                filter: {
                    published: 1,
                    leaderId: '',
                    memberId: window.appframe.$store.state.userInfo.id,
                    memberType: '2'
                },
                order: {}
            },
            currentStudio:{},
            studioDynamicList:[],
            activitys:[]
        }
    },
    mounted(){
        let vm = this
        vm.$nextTick(function(){
            vm.query()
        })
        
    },
    methods:{
        query(){
            let vm = this
            http.post('/gateway/masterstudio/studioInfo/param', vm.studioQuery.filter).then(function (xhr) {
                if(xhr.data.data && xhr.data.data.length > 0){
                    vm.studiosId = xhr.data.data[1].id
                    http.get('/gateway/masterstudio/studioInfo/' + vm.studiosId).then(function (xhr) {
                        vm.currentStudio = xhr.data.data
                    })

                    let studioDynamicTableQuery = {
                        page: 1,
                        size: vm.swWidth == 2 ? 5 : 10,
                        draw: 0,
                        filter: {
                            id: vm.studiosId,
                            isFirstData: '1'
                        }
                    }
                    let obj = $.extend({}, studioDynamicTableQuery, {
                                        filter: eduFilterParam(studioDynamicTableQuery.filter)
                    });
                    http.post('/gateway/masterstudio/studioDynamic/getByStudioIdInfos', obj).then(function(xhr){
                        vm.studioDynamicList = xhr.data.data
                    })

                    let activityQuery = {
                        page: 1,
                        size: 4,
                        filter: {
                            studioId: vm.studiosId,
                            partin: 1
                        }
                        };
                        activityQuery.filter = eduFilterParam(activityQuery.filter);
                    http.post("/gateway/learning/masterStudio/page", activityQuery).then(function (xhr) {
                        if (xhr.data.code) return;
                        vm.activitys = xhr.data.aaData;
                    })
                }
            })
            
        }
    }
}
</script>
<style lang="less" scoped>
    .warp_main{
        padding: 0 15px;
    }
    .count_main:after{
        content: '';
        clear: both;
        display: block;
    }
    .widget_level1{
        .count_item{
            float: left;
            width: 50%;
            margin-top: 30px;
            span{
                width: 48px;
                height: 48px;
                line-height: 48px;
                text-align: center;
                float: left;
                border-radius: 50%;
                margin-right: 10px;
                img{
                    vertical-align: middle;
                }
            }
            div{
                color: #666;
            }
            strong{
                margin-top: 5px;
                display: block;
            }
        }
        .count_item:nth-child(1){
            strong{
                color: #f89431;
            }
        }
        .count_item:nth-child(2){
            strong{
                color: #f89431;
            }
        }
        .count_item:nth-child(3){
            strong{
                color: #d437f1;
            }
        }
        .count_item:nth-child(4){
            strong{
                color: #06c2df;
            }
        }
        .count_item:nth-child(5){
            strong{
                color: #11de95;
            }
        }
        .count_item:nth-child(6){
            strong{
                color: #f89431;
            }
        }
    }
    .widget_level1{
        .count_item:nth-child(1){
            span{
                background: -webkit-linear-gradient(bottom,#3bb7fb, #1965f0);
                background: -o-linear-gradient(bottom,#3bb7fb, #1965f0);
                background: -moz-linear-gradient(bottom,#3bb7fb, #1965f0);
                background: linear-gradient(to bottom,#3bb7fb, #1965f0);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3bb7fb', endColorstr='#1965f0', GradientType=1);
            }
        }
        .count_item:nth-child(2){
            span{
                background: -webkit-linear-gradient(bottom,#ebed0e, #f8922d);
                background: -o-linear-gradient(bottom,#ebed0e, #f8922d);
                background: -moz-linear-gradient(bottom,#ebed0e, #f8922d);
                background: linear-gradient(to bottom,#ebed0e, #f8922d);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ebed0e', endColorstr='#f8922d', GradientType=1);
            }
        }
        .count_item:nth-child(3){
            span{
                background: -webkit-linear-gradient(bottom,#24eaa7, #02cef1);
                background: -o-linear-gradient(bottom,#24eaa7, #02cef1);
                background: -moz-linear-gradient(bottom,#24eaa7, #02cef1);
                background: linear-gradient(to bottom,#24eaa7, #02cef1);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#24eaa7', endColorstr='#02cef1', GradientType=1);
            }
        }
        .count_item:nth-child(4){
            span{
                background: -webkit-linear-gradient(bottom,#ff76b3, #d335f3);
                background: -o-linear-gradient(bottom,#ff76b3, #d335f3);
                background: -moz-linear-gradient(bottom,#ff76b3, #d335f3);
                background: linear-gradient(to bottom,#ff76b3, #d335f3);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff76b3', endColorstr='#d335f3', GradientType=1);
            }
        }
        .count_item:nth-child(5){
            span{
                background: -webkit-linear-gradient(bottom,#ecec0f, #26e9a6);
                background: -o-linear-gradient(bottom,#ecec0f, #26e9a6);
                background: -moz-linear-gradient(bottom,#ecec0f, #26e9a6);
                background: linear-gradient(to bottom,#ecec0f, #26e9a6);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ecec0f', endColorstr='#26e9a6', GradientType=1);
            }
        }
        .count_item:nth-child(6){
            span{
                background: -webkit-linear-gradient(bottom,#af6fff, #5659f8);
                background: -o-linear-gradient(bottom,#af6fff, #5659f8);
                background: -moz-linear-gradient(bottom,#af6fff, #5659f8);
                background: linear-gradient(to bottom,#af6fff, #5659f8);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#af6fff', endColorstr='#5659f8', GradientType=1);
            }
        }
    }
    .widget_level2{
        .count_item:nth-child(1){
            background: -webkit-linear-gradient(bottom,#3bb7fb, #1965f0);
            background: -o-linear-gradient(bottom,#3bb7fb, #1965f0);
            background: -moz-linear-gradient(bottom,#3bb7fb, #1965f0);
            background: linear-gradient(to bottom,#3bb7fb, #1965f0);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3bb7fb', endColorstr='#1965f0', GradientType=1);
        }
        .count_item:nth-child(2){
            background: -webkit-linear-gradient(bottom,#ebed0e, #f8922d);
            background: -o-linear-gradient(bottom,#ebed0e, #f8922d);
            background: -moz-linear-gradient(bottom,#ebed0e, #f8922d);
            background: linear-gradient(to bottom,#ebed0e, #f8922d);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ebed0e', endColorstr='#f8922d', GradientType=1);
        }
        .count_item:nth-child(3){
            background: -webkit-linear-gradient(bottom,#24eaa7, #02cef1);
            background: -o-linear-gradient(bottom,#24eaa7, #02cef1);
            background: -moz-linear-gradient(bottom,#24eaa7, #02cef1);
            background: linear-gradient(to bottom,#24eaa7, #02cef1);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#24eaa7', endColorstr='#02cef1', GradientType=1);
        }
        .count_item:nth-child(4){
            background: -webkit-linear-gradient(bottom,#ff76b3, #d335f3);
            background: -o-linear-gradient(bottom,#ff76b3, #d335f3);
            background: -moz-linear-gradient(bottom,#ff76b3, #d335f3);
            background: linear-gradient(to bottom,#ff76b3, #d335f3);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff76b3', endColorstr='#d335f3', GradientType=1);
        }
        .count_item:nth-child(5){
            background: -webkit-linear-gradient(bottom,#ecec0f, #26e9a6);
            background: -o-linear-gradient(bottom,#ecec0f, #26e9a6);
            background: -moz-linear-gradient(bottom,#ecec0f, #26e9a6);
            background: linear-gradient(to bottom,#ecec0f, #26e9a6);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ecec0f', endColorstr='#26e9a6', GradientType=1);
        }
        .count_item:nth-child(6){
            background: -webkit-linear-gradient(bottom,#af6fff, #5659f8);
            background: -o-linear-gradient(bottom,#af6fff, #5659f8);
            background:  -moz-linear-gradient(bottom,#af6fff, #5659f8);
            background: linear-gradient(to bottom,#af6fff, #5659f8);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#af6fff', endColorstr='#5659f8', GradientType=1);
        }
    }
    .widget_level2,
    .widget_level3{
        .count_main{
            margin-top: 15px;
        }
        .count_item{
            box-sizing: border-box;
            float: left;
            width: calc(~'16.66% - 16px');
            margin-left: 19px;
            border-radius: 8px;
            // background: #3ab4fb;
            color: #fff;
        }
        .count_item:first-child{
            margin-left: 0;
        }
        .dynamic_ceil{
            line-height: 16px;
            margin-bottom: 12px;
            clear: both;
            i{
                width: 4px;
                height: 4px;
                background: #333;
                border-radius: 50%;
                float: left;
                margin-top: 6px;
                margin-right: 10px;
            }
            div{
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                cursor: pointer;
            }
            div:hover{
                color: #4183fc;
            }
            span{
                float: right;
                color: #999;
                font-size: 12px;
            }
        }
        .activity_ceil{
            display: inline-block;
            width: 50%;
            margin-bottom: 15px;
            .type{
                background: #edf3fe;
                color: #666;
                border-radius: 3px;
                padding: 3px 5px;
                font-size: 12px;
                float: left;
            }
            .activity_info{
                margin-left:70px;
            }
            .activity_tit{
                font-weight: bold;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                cursor: pointer;
                line-height: 20px;
                margin-bottom: 5px;
            }
            .activity_tit:hover{
                color: #4183fc;
            }
            .activity_about{
                font-size: 12px;
                color: #666;
                margin-bottom: 5px;
                span{
                    margin-right: 15px;
                }
            }
            .status{
                font-size: 12px;
            }
            .color1{color: #da9c23;}
            .color2{color: #1ec698;}
            .color3{color: #666;}
        }
        .activity_ceil:nth-child(2n+1){
            padding-right:24px;
        }
        .activity_ceil:nth-child(2n+2){
            padding-left:24px;
        }
    }
    .widget_level2{
        .chart_el{
            margin-top: 15px;
        }
        .count_item{
            text-align: center;
            padding: 11px 15px;
             strong{
                 font-size: 18px;
             }
        }
    }
    .widget_level3{
        .chart_el{
            margin-top: 12px;
        }
        .count_item{
            font-size: 12px;
            padding: 15px;
            strong{
                float: right;
                line-height: 40px;
                font-size: 18px;
            }
        }
        .dynamic_ceil{
            width: 50%;
            display: inline-block;
        }
        .dynamic_ceil:nth-child(2n+1){
            padding-right:24px;
        }
        .dynamic_ceil:nth-child(2n+2){
            padding-left:24px;
        }
        .count_item:nth-child(1){
            background: url(../img/master/01.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(2){
            background: url(../img/master/02.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(3){
            background: url(../img/master/03.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(4){
            background: url(../img/master/04.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(5){
            background: url(../img/master/05.png) no-repeat;
            background-size: 100% 100%;
        }
        .count_item:nth-child(6){
            background: url(../img/master/06.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    .noData{
        height: 140px;
        background: url(~css_img/icon_emptypage.png) no-repeat center center;
        background-size: auto 100%;
    }
</style>
<style>
    .master_s_member .widget_body .el-tabs__nav{
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/homepage/widget/member.vue